//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Fade } from '@mui/material';
import styled from '@emotion/styled';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { ViewTypes } from '@/constants/constants';
import SlideToggle from '@/components/_common/SlideToggle';
import TextSearch from '@/components/_common/TextSearch';

type ListHeaderProps = {
  viewType: string;
  changeViewType: (viewType: ViewTypes) => void;
  relatedFilesLoading: boolean;
  showAllFiles: boolean;
  toggleShowAllFiles: () => void;
  relatedFilesCount: number; 
  fileFilter: string;
  onFileFilterChange: (filter: string) => void;
};

const ListHeader = ({ fileFilter, onFileFilterChange, viewType, changeViewType, relatedFilesLoading, showAllFiles, toggleShowAllFiles, relatedFilesCount }: ListHeaderProps) => {
  return (
    <Fade in timeout={600}>
      <Container>
        <LeftContents>
          <SlideToggle
            left={{ label: 'Job Files', value: 'job-files' }}
            right={{ label: 'All Files', value: 'all-files' }}
            callback={() => toggleShowAllFiles()}
            disabled={relatedFilesLoading}
            defaultUnchecked={!showAllFiles}
            alternateColors
          />
          <TextSearchField value={fileFilter} onChange={onFileFilterChange} />
        </LeftContents>
        <SlideToggle
          left={{ label: <PolarisIcon icon="menu" />, value: ViewTypes.list }}
          right={{ label: <PolarisIcon icon="grid" />, value: ViewTypes.grid }}
          disabled={relatedFilesLoading || relatedFilesCount <= 0}
          defaultUnchecked={viewType !== ViewTypes.grid}
          callback={(selected: ViewTypes) => changeViewType(selected)}
        />
      </Container>
    </Fade>
  );
};

export default ListHeader;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const LeftContents = styled.div`
  display: flex;
`;

const TextSearchField = styled(TextSearch)`
  margin-left: ${(props) => props.theme.spacing(1)};
`;